import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import AIMS_FLAVORS from 'lib/aimsFlavors';
import buildUrl from 'lib/buildUrl';
import { content as ContentPropType } from 'lib/CustomPropTypes';

import TeaseCard from 'components/TeaseCard';
import TeasePicture from 'components/TeasePicture';
import Link from 'components/Link';
import Unibrow from 'components/Unibrow';


// TODO, detach this from TeaseCard (props, isNative())
class SidebarTease extends TeaseCard {
  static propTypes = {
    content: ContentPropType.isRequired,
    vertical: PropTypes.string.isRequired,
  };

  render() {
    const { content } = this.props;
    const { id, computedValues, metadata = {} } = content;
    const unibrow = computedValues ? computedValues.unibrow : content.unibrow;

    const url = buildUrl(content);

    const classes = classNames(
      'sidebar-tease__container',
      {
        'sidebar-tease__sponsored': this.isNative(),
      },
    );

    const eyebrowToolkitClasses = ['f2', 'lh-none', 'founders-mono', 'fw1', 'ttu', 'ma0', 'mb1'];

    const showImage = metadata.showTeaseImage !== false && !!get(computedValues, 'teaseImage');

    return (
      <div className={classes} data-contentid={id}>
        {showImage && (
          <Link
            to={url}
            className="sidebar-tease__picture"
          >
            <TeasePicture
              responsiveFlavors={{
                s: AIMS_FLAVORS.FOCAL_80x80,
                xl: AIMS_FLAVORS.FOCAL_120x120,
              }}
              computedValues={computedValues}
            />
          </Link>
        )}
        <div className="sidebar-tease__info">
          <Unibrow
            className={classNames('sidebar-tease__category', eyebrowToolkitClasses)}
            size="h4"
            unibrow={unibrow}
          />
          <h3
            className="sidebar-tease__title"
          >
            <Link to={url}>
              { computedValues.headline }
            </Link>
          </h3>
        </div>
      </div>
    );
  }
}

export default SidebarTease;
